export default "__VITE_ASSET__DDHW9un9__"